import React from "react";

/**
 * Simple, low-footprint date-range filter.
 * Emits { period, from_date, to_date } matching the backend helper `_date_range`.
 *
 * Usage:
 *   <DateFilter value={filter} onChange={setFilter} />
 *   api.get("/memberships", { params: filter })
 */
export default function DateFilter({ value, onChange, testid = "date-filter" }) {
  const { period = "", from_date = "", to_date = "" } = value || {};
  const preset = (p) => onChange({ period: p, from_date: "", to_date: "" });
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={testid}>
      {[
        ["", "All"],
        ["day", "Today"],
        ["week", "Week"],
        ["month", "Month"],
        ["year", "Year"],
      ].map(([v, l]) => (
        <button
          key={v || "all"}
          onClick={() => preset(v)}
          className={`text-xs px-3 py-1.5 rounded-full border ${
            !from_date && !to_date && (period === v || (!period && !v))
              ? "bg-[#0F2540] text-white border-[#0F2540]"
              : "bg-white text-[#0F2540] border-[#E1E8F0] hover:border-[#1E4F87]"
          }`}
          data-testid={`${testid}-${v || "all"}`}
        >
          {l}
        </button>
      ))}
      <div className="flex items-center gap-1.5 ml-1">
        <input
          type="date"
          value={from_date}
          onChange={(e) => onChange({ period: "", from_date: e.target.value, to_date })}
          className="text-xs px-2 py-1.5 rounded-full border border-[#E1E8F0] bg-white"
          data-testid={`${testid}-from`}
        />
        <span className="text-xs text-[#5C6B7A]">→</span>
        <input
          type="date"
          value={to_date}
          onChange={(e) => onChange({ period: "", from_date, to_date: e.target.value })}
          className="text-xs px-2 py-1.5 rounded-full border border-[#E1E8F0] bg-white"
          data-testid={`${testid}-to`}
        />
      </div>
    </div>
  );
}
